/** @format */

import { RatingDistribution } from './rating-distribution.interface';
import { SecondaryRatingsAverages } from './secondary-ratings-averages.interface';

export interface ReviewStatistics {
  AverageOverallRating: number;
  OverallRatingRange: number;
  RatingDistribution: RatingDistribution[];
  RecommendedCount?: number | null;
  SecondaryRatingsAverages: { [key: string]: SecondaryRatingsAverages };
  SecondaryRatingsAveragesOrder: string[];
  TotalReviewCount: number;
}

export interface RatingSummaryIncludes {
  Products: {
    [key: string]: {
      ReviewStatistics: ReviewStatistics;
    };
  };
}
